import { useEffect, useState } from "react";
import {
  HeadContent,
  Outlet,
  Scripts,
  createRootRoute,
  useRouterState
} from "@tanstack/react-router";
import { GoogleAnalytics } from "../components/GoogleAnalytics";
import "../styles.css";

export const Route = createRootRoute({
  head: () => ({
    meta: [
      { charSet: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1.0" },
      { name: "theme-color", content: "#fff7fb" },
      { name: "apple-mobile-web-app-title", content: "Aesthetic Bio Maker" }
    ],
    links: [
      { rel: "icon", type: "image/png", href: "/favicon-96x96.png", sizes: "96x96" },
      { rel: "shortcut icon", href: "/favicon.ico" },
      { rel: "apple-touch-icon", href: "/apple-touch-icon.png", sizes: "180x180" },
      { rel: "manifest", href: "/site.webmanifest" }
    ]
  }),
  component: RootComponent
});

function RootComponent() {
  // Journey's custom-site integration requires the final layout after hydration.
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => setHydrated(true), []);
  const pathname = useRouterState({
    select: (state) => state.location.pathname
  });
  const language = pathname === "/es" || pathname.startsWith("/es/") ? "es" : "en";

  return (
    <html lang={language} suppressHydrationWarning>
      <head>
        <GoogleAnalytics />
        <script defer src="/clarity-init.js" data-project-id="ytecubov36" />
        <script defer src="/plausible-init.js" />
        <HeadContent />
        {/* Keep the wrapper on policy pages for Journey's privacy notice and consent controls. */}
        {hydrated && (
          <script
            type="text/javascript"
            async
            data-noptimize="1"
            data-cfasync="false"
            src="https://scripts.scriptwrapper.com/tags/baefa3f8-81b8-4019-85c4-b8c9df56fdeb.js"
          />
        )}
      </head>
      <body>
        <Outlet />
        <Scripts />
      </body>
    </html>
  );
}
